import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTelegramAccounts } from '../../../hooks/useTelegramAccounts';
import { TelegramAccountStep } from '../../SendingScheduleWizard/Steps';

export interface TelegramAccountsStepProps {
  checkedTelegramAccounts: Record<string, boolean>;
  onCheckTelegramAccounts: (checkedTelegramAccounts: Record<string, boolean>) => void;
  onAvailabilityChange: (hasTelegramAccounts: boolean) => void;
}

const TelegramAccountsStep: React.FC<TelegramAccountsStepProps> = ({
  checkedTelegramAccounts,
  onCheckTelegramAccounts,
  onAvailabilityChange
}) => {
  const navigate = useNavigate();
  const { items, isLoading, pagination, search, load, loadInitial, onSearch } = useTelegramAccounts({ perPage: 10 });

  useEffect(() => {
    loadInitial();
  }, [loadInitial]);

  useEffect(() => {
    if (!isLoading && !search) {
      onAvailabilityChange((pagination.total || 0) > 0);
    }
  }, [isLoading, search, pagination.total, onAvailabilityChange]);

  const handleSelect = useCallback((accountId: string, selected: boolean) => {
    const next = { ...checkedTelegramAccounts };
    if (selected) {
      next[accountId] = true;
    } else {
      delete next[accountId];
    }
    onCheckTelegramAccounts(next);
  }, [checkedTelegramAccounts, onCheckTelegramAccounts]);

  return (
    <TelegramAccountStep
      multiSelect
      telegramAccounts={items}
      isLoading={isLoading}
      pagination={pagination}
      selectedTelegramAccount={checkedTelegramAccounts}
      searchTerm={search}
      onTelegramAccountSelect={handleSelect}
      onPageChange={(page: number) => { load(page, search); }}
      onSearchChange={onSearch}
      onCreateTelegramAccount={() => navigate('/telegram_accounts/create')}
    />
  );
};

export default TelegramAccountsStep;
